// extracted by mini-css-extract-plugin
export var carrierTab = "_5a-0";
export var carrierTabActive = "_5a-1 _5a-0";
export var carrierTabInactive = "_5a-2 _5a-0";
export var carrierTabLabel = "_5a-3";
export var carrierTabLabelActive = "_5a-4 _5a-3";
export var carrierTabLabelInactive = "_5a-5 _5a-3";
export var carrierTabPercentage = "_5a-6";
export var carrierTabPercentageActive = "_5a-7 _5a-6";
export var carrierTabPercentageInactive = "_5a-8 _5a-6";
export var carrierTabWinnable = "_5a-9";
export var carrierTabWinnableActive = "_5a-a _5a-9";
export var carrierTabWinnableInactive = "_5a-b _5a-9";
export var comparisonContainer = "_5a-d";
export var missingRateButton = "_5a-n";
export var missingRateButtonActive = "_5a-o _5a-n";
export var missingRateButtonInactive = "_5a-p _5a-n";
export var missingRateButtonLabel = "_5a-q";
export var missingRateButtonLabelActive = "_5a-r _5a-q";
export var missingRateButtonLabelInactive = "_5a-s _5a-q";
export var sidebar = "_5a-c";
export var strategyButton = "_5a-e";
export var strategyButtonActive = "_5a-f _5a-e";
export var strategyButtonDescription = "_5a-k";
export var strategyButtonDescriptionActive = "_5a-l _5a-k";
export var strategyButtonDescriptionInactive = "_5a-m _5a-k";
export var strategyButtonInactive = "_5a-g _5a-e";
export var strategyButtonLabel = "_5a-h";
export var strategyButtonLabelActive = "_5a-i _5a-h";
export var strategyButtonLabelInactive = "_5a-j _5a-h";
export var unitToggleButton = "_5a-t";
export var unitToggleButtonActive = "_5a-u _5a-t";
export var unitToggleButtonInactive = "_5a-v _5a-t";
export var unitToggleButtonLabel = "_5a-w";
export var unitToggleButtonLabelActive = "_5a-x _5a-w";
export var unitToggleButtonLabelInactive = "_5a-y _5a-w";